import * as React from "react";
import {VeboxTreeView, VeboxTreeViewInputItemProps} from "../VeboxTreeView";
import {VeboxSelectionListActionType} from "../../selection_list/VeboxSelectionList";
import {getValidChildren, useValue} from "../../../users/HierarchyVisibilityUtils";
import {VeboxTreeViewItemProps} from "./VeboxTreeViewItem";
import {CheckboxState} from "./VeboxTreeViewCheckbox";

export const VeboxTreeViewCheckboxWithoutIndeterminate: React.FC<VeboxTreeViewInputItemProps & VeboxTreeViewItemProps & React.HTMLAttributes<any>> = ({
                                                                                                                                                          value,
                                                                                                                                                          onChange,
                                                                                                                                                          checked,
                                                                                                                                                          indeterminate,
                                                                                                                                                          disabled,
                                                                                                                                                          siblings,
                                                                                                                                                          children,
                                                                                                                                                          label,
                                                                                                                                                          className,
                                                                                                                                                          ...rest
                                                                                                                                                      }
) => {

    const [state, setState] = React.useState<CheckboxState>({
        value,
        checked,
        indeterminate,
        children: [],
    });

    const childrenValues = getValidChildren(children).map((child: any) => child?.props?.value);
    const numberOfChildren = getValidChildren(children).length;

    const handleCheckboxChange = (val, action: VeboxSelectionListActionType) => {
        switch (action) {
            case VeboxSelectionListActionType.ADD: {
                const currentNodeChildren = [...state.children.filter(v => useValue(v) !== useValue(val)), val]
                const checkedChildren = currentNodeChildren.filter(
                    child => typeof child === "string" || child.checked);
                const payload: CheckboxState = {
                    value,
                    checked: (checkedChildren.length === numberOfChildren) && false,
                    indeterminate: 0 < currentNodeChildren.length && checkedChildren.length !== numberOfChildren,
                    children: currentNodeChildren,
                }
                onChange(payload, VeboxSelectionListActionType.ADD);
                break;
            }
            case VeboxSelectionListActionType.REMOVE: {
                const currentNodeChildren = [...state.children.filter(v => useValue(v) !== useValue(val))];
                const checkedChildren = currentNodeChildren.filter(
                    child => typeof child === "string" || child.checked);
                const payload: CheckboxState = {
                    value,
                    checked: (checkedChildren.length === numberOfChildren) && false,
                    indeterminate: 0 < currentNodeChildren.length && checkedChildren.length !== numberOfChildren,
                    children: currentNodeChildren,
                }
                onChange(payload,
                    payload.children.length === 0 ? VeboxSelectionListActionType.REMOVE : VeboxSelectionListActionType.ADD); // Adding is like updating
                break;
            }
        }
    };

    const nodeChange = (e) => {
        if (e.target.checked) {
            onChange(value, VeboxSelectionListActionType.ADD);
        } else {
            onChange(value, VeboxSelectionListActionType.REMOVE);
        }
    };

    const ref = React.useRef<HTMLInputElement>();

    React.useEffect(() => {
        const newState = siblings.find(v => useValue(v) === value);
        if (typeof newState === 'object') {
            setState(newState);
        } else if (typeof newState === 'string') {

            const temp = {
                value: useValue(newState),
                checked: true,
                indeterminate: false,
                children: childrenValues,
            };
            setState(temp);
        } else {
            const temp = {
                value: useValue(newState),
                checked: false,
                indeterminate: false,
                children: [],
            };
            setState(temp);
        }
    }, [siblings]);

    return (
        <VeboxTreeView.Item
            {...({
                ...rest,
                parentValue: undefined,
                parentState: undefined,
                onChange: undefined,
            })}
            label={
                <>
                    <input
                        type={"checkbox"}
                        value={value}
                        checked={state.checked}
                        disabled={disabled}
                        onChange={nodeChange}
                        className={"checkbox"}
                        ref={ref}
                    />
                    {label}
                </>
            }
            className={className + (disabled ? " vebox-tree-view-disabled" : "")}
        >
            {React.Children.toArray(children)
                .filter(Boolean)
                .map((child: any) => {
                    return React.cloneElement(
                        child,
                        {
                            ...child.props,
                            onChange: handleCheckboxChange,
                            siblings: state.children ?? [],
                            disabled: disabled || child?.props?.disabled,
                            className: child?.props?.className + className + ((disabled || child?.props?.disabled) ? " vebox-tree-view-disabled" : ""),
                        }
                    )
                })
            }
        </VeboxTreeView.Item>
    );
}